import { render, staticRenderFns } from "./excursion-categorys.vue?vue&type=template&id=5f7f356e&"
import script from "./excursion-categorys.vue?vue&type=script&lang=ts&"
export * from "./excursion-categorys.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports